import { EyeInvisibleOutlined } from "@ant-design/icons";
import React from "react";
import { $t } from "~/i18n.js";
import { deserializePhone } from "../../lib/localize.js";

export const Phone = ({ number, private_mode = false }) => {
  return (
    <div className="row">
      {private_mode && <EyeInvisibleOutlined style={{ margin: "1px 2px 0 0" }} />}
      <p style={{ marginLeft: private_mode ? 6 : 0, marginRight: 18 }}>
        {number ? deserializePhone(number) : $t("onbekend")}
      </p>
    </div>
  );
};
